var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"layout":"column"}},[_c('div',{staticClass:"subheading font-weight-light ml-2 mb-2",attrs:{"layout":"row"}},[_vm._v(" Session per target groups ")]),_c('div',{staticClass:"font-weight-bold title",attrs:{"layout":"row"}},[(_vm.showGraph)?_c('canvas',{attrs:{"id":"myChart","height":"400"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }